module.exports = __webpack_public_path__ + "img/logotext.b9f83689.svg";